import { SagaIterator } from 'redux-saga';
import { fork, takeEvery, takeLatest } from 'redux-saga/effects';
import { ChangeExtractDsToLive, EditConnections, GroupDatabases, RemoveExternalContentAction, SetCertification, SetContact, SetDataQuality, SetDescription, SetExternalTags } from '../../actions/AppActionTypes';
import { rootBackgroundJobSaga } from './backgroundJobs/BackgroundJobSagas';
import { rootCollectionSaga } from './content/CollectionSagas';
import { handleGroupDatabases } from './content/GroupDatabasesSaga';
import { handleRemoveExternalContent } from './content/RemoveExternalContentSaga';
import { rootContentSaga } from './content/RootContentSaga';
import { handleSetCertification } from './content/SetCertificationSaga';
import { handleSetContact } from './content/SetContactSaga';
import { handleSetDataQuality } from './content/SetDataQualitySaga';
import { handleSetDescription } from './content/SetDescriptionSaga';
import { rootContentCreationSaga } from './ContentCreationSagas';
import { rootContentSelectionSaga } from './ContentSelectionSagas';
import { rootDataAlertMenuActionSaga } from './DataAlertMenuSagas';
import { handleEditDataConnectionAction } from './EditConnectionSaga';
import { handleChangeExtractDsToLiveAction } from './extractTasks/ChangeExtractDsToLiveSaga';
import { rootExtractRefreshSaga } from './extractTasks/RootExtractRefreshSaga';
import { rootGroupMenuActionSaga } from './GroupMenuSagas';
import { rootMetricSpaceSagas } from './MetricsSpaceSaga';
import { rootRunFlowTaskMenuActionSaga } from './RunFlowTaskMenuSaga';
import { rootScheduleMenuActionSaga } from './ScheduleMenuSagas';
import { rootServerUserMenuActionSaga } from './ServerUserMenuSagas';
import { handleSetExternalContentTags } from './SetTagsSagas';
import { rootSiteMenuActionSaga } from './SiteMenuActionSagas';
import { rootSiteUserMenuActionSaga } from './SiteUserMenuSagas';
import { rootMetricSaga } from './workbooks/MetricSagas';
import { rootWorkbookSaga } from './workbooks/WorkbookSagas';

export function* rootSpacesSaga(): SagaIterator {
  yield fork(rootContentCreationSaga);
  yield fork(rootContentSaga);
  yield fork(rootContentSelectionSaga);
  yield fork(rootCollectionSaga);
  yield fork(rootExtractRefreshSaga);
  yield fork(rootWorkbookSaga);
  yield fork(rootMetricSaga);
  yield fork(rootMetricSpaceSagas);
  yield fork(rootBackgroundJobSaga);
  yield fork(rootDataAlertMenuActionSaga);
  yield fork(rootRunFlowTaskMenuActionSaga);
  yield fork(rootScheduleMenuActionSaga);
  yield fork(rootSiteMenuActionSaga);
  yield fork(rootSiteUserMenuActionSaga);
  yield fork(rootServerUserMenuActionSaga);
  yield fork(rootGroupMenuActionSaga);
  yield takeLatest(SetDataQuality, handleSetDataQuality);
  yield takeLatest(SetDescription, handleSetDescription);
  yield takeLatest(SetCertification, handleSetCertification);
  yield takeLatest(GroupDatabases, handleGroupDatabases);
  yield takeLatest(SetExternalTags, handleSetExternalContentTags);
  yield takeLatest(SetContact, handleSetContact);
  yield takeLatest(RemoveExternalContentAction, handleRemoveExternalContent);
  yield takeEvery(EditConnections, handleEditDataConnectionAction);
  yield takeEvery(ChangeExtractDsToLive, handleChangeExtractDsToLiveAction);
}
